import { createAction } from 'redux-actions'

const GET_ICE_INFO = 'GET_ICE_INFO'
const NOTIFY_ICE_SERVERS = 'NOTIFY_ICE_SERVERS'
const RESOLVE_AGENT_ADDRESS = 'RESOLVE_AGENT_ADDRESS'
const RESOLVE_INSTALLED_AGENT_ADDRESS = 'RESOLVE_INSTALLED_AGENT_ADDRESS'
const NOTIFY_AGENT_ADDRESS = 'NOTIFY_AGENT_ADDRESS'
const NOTIFY_USER_DETAILS = 'NOTIFY_USER_DETAILS'
const SEND_OFFER = 'SEND_OFFER'
const NOTIFY_AGENT_DESCRIPTION = 'NOTIFY_AGENT_DESCRIPTION'
const NOTIFY_AGENT_ICE_CANDIDATE = 'NOTIFY_AGENT_ICE_CANDIDATE'
const NOTIFY_ACK = 'NOTIFY_ACK'
const NOTIFY_NACK = 'NOTIFY_NACK'
const NOTIFY_DISCONNECT = 'NOTIFY_DISCONNECT'
const NOTIFY_NRC_ERROR_RESPONSE = 'NOTIFY_NRC_ERROR_RESPONSE'
const SEND_ICE_CANDIDATE = 'SEND_ICE_CANDIDATE'
const DESCRIPTIONS_IN_SYNC = 'DESCRIPTIONS_IN_SYNC'
const GET_USER_DETAILS_FROM_TOKEN_REQUEST = 'GET_USER_DETAILS_FROM_TOKEN_REQUEST'
const NOTIFY_NO_PERMISSION = 'NOTIFY_NO_PERMISSION'
const NOTIFY_CONNECTION_LIMIT_REACHED = 'NOTIFY_CONNECTION_LIMIT_REACHED'
const NOTIFY_AGENT_DETAILS = 'NOTIFY_AGENT_DETAILS'

export const getIceInfo = createAction(GET_ICE_INFO)
export const notifyIceServers = createAction(NOTIFY_ICE_SERVERS)
export const resolveAgentAddress = createAction(RESOLVE_AGENT_ADDRESS)
export const resolveInstalledAgentAddress = createAction(RESOLVE_INSTALLED_AGENT_ADDRESS)
export const notifyAgentAddress = createAction(NOTIFY_AGENT_ADDRESS)
export const notifyUserDetails = createAction(NOTIFY_USER_DETAILS)
export const sendOffer = createAction(SEND_OFFER)
export const notifyAgentDescription = createAction(NOTIFY_AGENT_DESCRIPTION)
export const notifyAgentIceCandidate = createAction(NOTIFY_AGENT_ICE_CANDIDATE)
export const sendIceCandidate = createAction(SEND_ICE_CANDIDATE)
export const descriptionsInSync = createAction(DESCRIPTIONS_IN_SYNC)
export const notifyAck = createAction(NOTIFY_ACK)
export const notifyNack = createAction(NOTIFY_NACK)
export const notifyDisconnect = createAction(NOTIFY_DISCONNECT)
export const notifyNrcErrorResponse = createAction(NOTIFY_NRC_ERROR_RESPONSE)
export const getUserDetailsFromTokenRequest = createAction(GET_USER_DETAILS_FROM_TOKEN_REQUEST)
export const notifyNoPermission = createAction(NOTIFY_NO_PERMISSION)
export const notifyConnectionLimitReached = createAction(NOTIFY_CONNECTION_LIMIT_REACHED)
export const notifyAgentDetails = createAction(NOTIFY_AGENT_DETAILS)

// dummyAction for netop.rc.portal.cm.ListAgentsResponse message
export const dummyAction = createAction('DUMMY_ACTION')
